/* eslint-disable @typescript-eslint/naming-convention */

/**
 * @author        joseph.murphy@zumper.com (murph)
 * @copyright     Copyright (c) 2023, Zumper
 */

import React, { useState, useCallback } from 'react'

import { selectEntity } from '@zcode-ui/web-zumper-global-state'
import { useSelector } from 'react-redux'
import type { SendMessageAlcArgs } from '../../../actions/sendMessage'
import { AlcCheckbox as AlcCheckboxComponent } from './AlcCheckbox'
import { useAlcSendMessage } from './useAlcSendMessage'

type InitAlcArgs = Omit<SendMessageAlcArgs, 'listingIds' | 'buildingIds'>
type AlcInitProps = { initialCheckboxValue: boolean | undefined }

export const useAlcInit = (props?: AlcInitProps) => {
  const [isChecked, setIsChecked] = useState(() => props?.initialCheckboxValue ?? true)
  const [isLoading, setIsAlcLoading] = useState(false)
  const entity = useSelector(selectEntity)
  const { postAlcSendMessage } = useAlcSendMessage()

  const initAlc = useCallback(
    async (initAlcArgs: InitAlcArgs) => {
      try {
        setIsAlcLoading(true)
        if (isChecked && initAlcArgs.entity) {
          return await postAlcSendMessage({ ...initAlcArgs })
        }
      } catch {
      } finally {
        setIsAlcLoading(false)
      }
    },
    [isChecked, postAlcSendMessage]
  )

  return {
    alcCheckbox: (
      <AlcCheckboxComponent
        isChecked={isChecked}
        isMmPrevent={entity?.isMmPrevent}
        onChange={setIsChecked}
      />
    ),
    initAlc,
    isAlcCheckboxChecked: isChecked,
    isAlcLoading: isLoading,
    setIsAlcCheckboxChecked: setIsChecked,
  }
}
